import {
  Stack,
  Typography,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

const AccountingSectionTable = ({ title, totalsSection, items, sx }) => {
  const intl = useIntl();

  return (
    <Stack sx={sx}>
      {title ? <Typography variant="labelLarge">{title}</Typography> : null}
      {!totalsSection ? (
        <Stack direction="row">
          <Typography flex={2} variant="labelLarge">
            {intl.formatMessage(messages.accountingColumnHeader)}
          </Typography>
          <Typography flex={1} textAlign="right" variant="labelLarge">
            {intl.formatMessage(messages.requestedAmountColumnHeader)}
          </Typography>
          <Stack
            sx={{
              flex: 1,
              position: 'relative',
              right: { xs: 0, md: -(21 + 4) }, // -(iconSize + gap)
            }}
            direction={'row'}
            gap={0.5}
            justifyContent={'flex-end'}
          >
            <Typography
              textAlign="right"
              variant="labelLarge"
              sx={{ whiteSpace: { xs: undefined, lg: 'nowrap' } }}
            >
              {intl.formatMessage(messages.caHudApprovedAmountColumnHeader)}
            </Typography>
            <Tooltip
              title={intl.formatMessage(messages.caHudApprovedAmountTooltip)}
              placement={'top'}
            >
              <AlertInfoIcon />
            </Tooltip>
          </Stack>
        </Stack>
      ) : null}

      <Stack gap={2}>
        {items?.map((item) => (
          <Stack key={item?.key} direction="row" gap={2}>
            <Typography flex={2} variant="bodyMedium" color="text.secondary">
              {item?.label}
            </Typography>
            <Typography
              flex={1}
              textAlign="right"
              variant="labelLarge"
              color="text.secondary"
            >
              {item?.requestedAmount}
            </Typography>
            <Typography
              flex={1}
              textAlign="right"
              variant="labelLarge"
              color="text.secondary"
            >
              {item?.caHudApprovedAmount}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default AccountingSectionTable;
